import { FormRestructureEvent } from "../core/";
import { validationServiceInstance } from "./service";

let added = false;

/**
 * @param {InputEvent} ev 
 */
function blockNegativeInput(ev) {
	if (ev.data && ev.data.includes("-")) {
			ev.preventDefault();
	}
}

/**
 * @param {HTMLFormElement} form 
 */
export function addPositiveValidation(form) {
	form.addEventListener("restructure", event => {
		if (!(event instanceof FormRestructureEvent)) return;

		for (const entry of event.added) {
			if (!entry.field) continue;

			/** @type {NodeListOf<HTMLInputElement>} */	
			const inputs = entry.field.querySelectorAll(`:scope input[type="number"]`);

			for (const input of inputs) {
				if (input.dataset.inputPositive !== "true") continue;

				input.addEventListener("beforeinput", blockNegativeInput);
			}
		}
	});

	if (!added) {
		added = true;
		validationServiceInstance.addProvider("positive", positiveValidationProvider);
	}
}

export const defaultPositiveErrorMessage = "Must not have a negative value.";

/**
 * @type {import("aspnet-client-validation").ValidationProvider}
 */
export const positiveValidationProvider = (value, element, params) => {
	if (!(element instanceof HTMLInputElement)) return true;
	if (element.type !== "number") return true;
	if (!element.dataset.valPositive) return true;
	
	return !value.startsWith("-");
}
